export const formatCurrency = (num) => {
    return new Intl.NumberFormat('en-IN').format(num);
}